"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ObfuscatingGuardResult = void 0;
var ObfuscatingGuardResult;
(function (ObfuscatingGuardResult) {
    ObfuscatingGuardResult["ForceTransform"] = "ForceTransform";
    ObfuscatingGuardResult["Ignore"] = "Ignore";
    ObfuscatingGuardResult["Transform"] = "Transform";
})(ObfuscatingGuardResult = exports.ObfuscatingGuardResult || (exports.ObfuscatingGuardResult = {}));
